import { render, staticRenderFns } from "./_PullChick.vue?vue&type=template&id=e505df08&"
import script from "./_PullChick.vue?vue&type=script&lang=js&"
export * from "./_PullChick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports